import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { DropdownItem } from 'reactstrap';

import NavigationEntity from '../../../types/NavigationEntity';
import MaybeExternalLink from '../../common/MaybeExternalLink';
import NavigationDropdownSubmenu from '../../common/NavigationDropdownSubmenu';

@observer
class NavigationMenuRowDropdownItem extends Component {
  render() {
    const { item, isNoFollowLink } = this.props;
    const { image, label, type, path } = item;

    if (item.children && item.children.length > 0) {
      return (
        <NavigationDropdownSubmenu labelText={item.label} to={item.path}>
          {item.children.map((subItem) => (
            <NavigationMenuRowDropdownItem
              item={subItem}
              isNoFollowLink={isNoFollowLink}
              key={subItem.id}
            />
          ))}
        </NavigationDropdownSubmenu>
      );
    } else {
      return (
        <DropdownItem
          key={item.id}
          tag={MaybeExternalLink}
          to={path}
          type={type}
          className="NavigationMenuRowDropdownItem"
          aria-label={item.accessible_text}
          isNoFollowLink={isNoFollowLink}
        >
          {image && <img src={image} alt={image} loading="lazy" />}
          {label}
        </DropdownItem>
      );
    }
  }
}

NavigationMenuRowDropdownItem.propTypes = {
  item: NavigationEntity.isRequired,
  isNoFollowLink: PropTypes.bool,
};

export default NavigationMenuRowDropdownItem;
